import { getFromLocalStorage, safeString } from "./utils";

export const selectStakeholder = (state) => state?.yodaStakeholders?.me;

export const selectCustomer = (state) => state?.yodaCustomer?.customer;

export const selectOrderState = (state) => state?.yodaOrders || {};

export const selectCatalogueState = (state) => state?.yodaCatalogue || {};

export const selectSystemState = (state) => state?.system || {};

export const selectOrderRows = (state) =>
  selectOrderState(state).orderRowDetails || {};

export const selectOrderDetails = (state) =>
  selectOrderState(state).orderDetails || [];

export const selectActiveCustomerCode = (state) => {
  const customer = selectCustomer(state);
  if (customer?.code) {
    return safeString(customer.code);
  }

  const persisted = getFromLocalStorage("selectedCustomerCode");
  return safeString(persisted);
};

export const selectUserRole = (state) => selectStakeholder(state)?.role;

export const selectOrderMetadata = (state) => {
  const orderState = selectOrderState(state);
  return {
    order: orderState.order,
    totalReorder: orderState.totalReorder,
    totalSwap: orderState.totalSwap,
    maxSwap: orderState.maxSwap,
  };
};

export const selectCheckoutStatus = (state) =>
  selectOrderState(state)?.statusCode;

export const selectLanguageFromState = (state) =>
  state?.system?.language || undefined;

export const selectOrderConfiguration = (state) =>
  selectOrderState(state).configuration || [];

export const selectPersistedCustomerId = () =>
  getFromLocalStorage("selectedCustomer");

export const selectPersistedAgentId = () =>
  getFromLocalStorage("selectedAgent");
